import {
    AdoptionJourneyInputSchema,
    type AdoptionJourneyInput,
} from "@/features/adoption-journey";

type JourneyListing = {
    title: string | null;
    breedNames: string[];
    weightBucket: string | null;
    media: Array<{ url: string | null }>;
    breeds: Array<{ name: string; size: string | null }>;
    breedEconomics: AdoptionJourneyInput["breedEconomics"];
};

export function toAdoptionJourneyInput(
    dogId: string,
    dog: JourneyListing,
): AdoptionJourneyInput {
    return AdoptionJourneyInputSchema.parse({
        dogId,
        dogPhoto: dog.media.find((item) => Boolean(item.url))?.url ?? "",
        breedName:
            dog.breedNames[0] ?? dog.breeds[0]?.name ?? dog.title ?? "new dog",
        breedSize: dog.weightBucket ?? dog.breeds[0]?.size ?? null,
        breedEconomics: dog.breedEconomics,
    });
}
